var map = {
	"./adult/nn/wordchain-data.json": 655,
	"./adult/no/wordchain-data.json": 656,
	"./child/se/wordchain-data.json": 657,
	"./youth/de/wordchain-data.json": 658,
	"./youth/nn/wordchain-data.json": 659,
	"./youth/no/wordchain-data.json": 660,
	"./youth/se/wordchain-data.json": 661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 654;